'use strict';

const analyticsHelper = require('../util/analyticsHelper');

/**
 * Manages the annual report selection and displays the corresponding content
 */
function initAnnualReports() {
    $('.annual-reports .report-year-select').on('change', function() {
        var selectedYear = $(this).val();
        var $container = $(this).closest('.annual-reports');

        $container.find('.report-content').hide();

        $container.find('.report-' + selectedYear).show();
    });
}

/**
 * Manages the financial topics selection and displays the corresponding content
 */
function initFinancialTopics() {    
    $('.financial-info .info-topic').on('change', function() {
        var selectedTopic = $(this).val();
        var $container = $(this).closest('.financial-info');

        $container.find('.topic-content').removeClass('active');

        $container.find('[data-topic="' + selectedTopic + '"]').addClass('active');
        var $activeTopic = $container.find('.topic-content.active');

        if($activeTopic.data('show-date-filter') === true) {
            $activeTopic.addClass('with-year-select');
            $('.year-select').show();
            $('.year').trigger('change');
        } else {
            $activeTopic.removeClass('with-year-select');
            $('.year-select').hide();
        }
    });

    
    $('.financial-info .year').on('change', function() {
        var selectedYear = $(this).val();
        var $container = $(this).closest('.financial-info');
        var $activeTopic = $container.find('.topic-content.active');

        $activeTopic.find('[data-year]').hide();

        $activeTopic.find('[data-year="' + selectedYear + '"]').show();
    });

    $('.financial-info .info-topic').trigger('change');
}

module.exports = {
    initComponents: function() {
        // Initialize annual reports if present on page
        if ($('.annual-reports').length > 0) {
            initAnnualReports();
        }

        // Initialize financial topics if present on page
        if ($('.financial-info').length > 0) {
            initFinancialTopics();
        }
    },

    initViewPromotionEvent: function() {
        $('.banner-asset-container').on('click', function () {
            analyticsHelper.trackEvent('view_promotion');
        });
    }
};